/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useId } from 'react';

import { jsx } from '@atlaskit/css';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { Stack } from '@atlaskit/primitives/compiled';
import { RadioGroup } from '@atlaskit/radio';

type Props = {
	label: string;
	name: string;
	isRequired: boolean;
	options: { label: string; value: string }[];
};

export const RadioGroupInput = ({ label, name, isRequired, options }: Props): JSX.Element => {
	const labelId = useId();
	return (
		<Stack space="space.050">
			<Label id={labelId} htmlFor={name}>
				{label}
				{isRequired && <RequiredAsterisk />}
			</Label>
			<RadioGroup name={name} options={options} isRequired={isRequired} labelId={labelId} />
		</Stack>
	);
};
